import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Types} from "components/index";
import PropTypes from "prop-types";
import APPCONFIG from "../../constants/Config";


/**
 *  @property {Tickets_Notes_Object} state
 *  @property {object} model
 *  @property {Tickets_Notes_Properties} model.properties
 *  @property {Tickets_Notes_Is} model.is
 *  @property {Tickets_Notes_Has} model.has
 */
export default class TicketNote extends Framework.Components.Object {

	constructor(props) {
		super(props, Types.Tickets_Notes._name);
		this.redirect = this.props.baseUrl;
		this.state.files = [];
	}

	form = () => {
		/** @param {Tickets_Notes_Properties} data */
		let {properties} = this.model
		/** @type {Tickets_Notes_Object} object */
		let object = this.state;
		let {loading}= this.state;

		return (
			<div>
				<fieldset>
					<div className={"row"}>
						<div className={"col-sm-4"}>
							<h4 className="section-title">Mandatory Four Point Inspection</h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Backup Note"}
									value={object.mandatory_backup_note}
									error={object.mandatory_backup_note_error}
									property={properties.mandatory_backup_note}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Hdd Note"}
									value={object.mandatory_hdd_note}
									error={object.mandatory_hdd_note_error}
									property={properties.mandatory_hdd_note}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Virus Note"}
									value={object.mandatory_virus_note}
									error={object.mandatory_virus_note_error}
									property={properties.mandatory_virus_note}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Network Notes"}
									value={object.mandatory_network_note}
									error={object.mandatory_network_note_error}
									property={properties.mandatory_network_note}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
						<div className={"col-lg"}>
							<h4 className="section-title">Recommended Work Order Notes</h4>
							<div className={"row"}>
								<div className={"col-md"}>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Hdd Smart Status"}
											value={object.hdd_smart_status}
											error={object.hdd_smart_status_error}
											property={properties.hdd_smart_status}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Drive Smart Status"}
											value={object.drive_smart_value}
											error={object.drive_smart_value_error}
											property={properties.drive_smart_value}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Drive Smart ID"}
											value={object.drive_smart_ids}
											error={object.drive_smart_ids_error}
											property={properties.drive_smart_ids}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"HHD Tune Results"}
											value={object.hhd_tune_result}
											error={object.hhd_tune_result_error}
											property={properties.hhd_tune_result}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Temperatures"}
											value={object.temps}
											error={object.temps_error}
											property={properties.temps}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Anti Virus Installed"}
											value={object.antivirus}
											error={object.antivirus_error}
											property={properties.antivirus}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>

								</div>

								<div className={"col-md"}>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Malware Scan"}
											value={object.malware_scan}
											error={object.malware_scan_error}
											property={properties.malware_scan}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Backup Type"}
											value={object.backup_type}
											error={object.backup_type_error}
											property={properties.backup_type}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Carbonite Subscription"}
											value={object.carbonite}
											error={object.carbonite_error}
											property={properties.carbonite}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
									{/*/!*TODO: Carbonite Link*!/*/}
									<div className="form-group">
										<Framework.Elements.DateTime
											label={"Schedule Appointment"}
											value={object.schedule_appt}
											error={object.schedule_appt_error}
											property={properties.schedule_appt}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Checkup Service"}
											value={object.checkup_service}
											error={object.checkup_service_error}
											property={properties.checkup_service}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Positive Feedback"}
											value={object.positive_feedback}
											error={object.positive_feedback_error}
											property={properties.positive_feedback}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className={"row"}>
						<div className={"col-lg"}>
							<h4 className="section-title">Detailed Notes </h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Detailed Notes"}
									value={object.detailed_notes}
									error={object.detailed_notes_error}
									property={properties.detailed_notes}
									update={this.handleTextFieldPropertyUpdate}
									multiline = {true}
								/>
							</div>
						</div>
					</div>
					<div className={'row'}>
						<div className={'col-12'}>
							<h4 className={'section-title'}> Images </h4>
							<div className={'form-group'}>
								<p>
									Upload any images relevant to the ticket here.
									<br/>
									<span>Current Images : <br/>
										{object.images_multiple && object.images_multiple.split('|').map((image, i) => {
											return(
												<b>{image}<br/></b>
											)
										})}
										<br/>
										<i>Upload a new file to replace the old one.</i>
									</span>
								</p>
								<Framework.Elements.DropZone
									property={properties.images_multiple}
									value={object.images_multiple}
									error={object.images_multiple}
									multiple={true}
									update={this.handleMultipleFileChange}
									label={'Drag \'n\' drop front image here, or click to select image'}
								/>
							</div>
							{object.images_multiple && object.images_multiple.split('|').map((image, i) => {
								return(<div>
									<img
										src={APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + '/tickets/' + object.ticket + '/images/' + this.state.pkey + '?image=' + image}
										alt={image}
										style={{maxWidth: '100%'}}
									/>
								</div>)})
							}
						</div>
					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	}
}
